module.exports = __webpack_public_path__ + "static/media/365.bb235857.svg";